module.exports = function() {
  return new Worker(__webpack_public_path__ + "22bf3daf93e35aaf272f.worker.js");
};